import React from 'react';
import { Box, Alert, Button, CircularProgress } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import {
  loadingContainerStyles,
  errorContainerStyles,
  errorAlertStyles,
} from './WorkflowResponseForm.styles';

interface LoadingSpinnerProps {
  loading: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ loading }) => {
  if (!loading) return null;

  return (
    <Box sx={loadingContainerStyles}>
      <CircularProgress />
    </Box>
  );
};

interface ErrorDisplayProps {
  error: string | null;
  onBack: () => void;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  error,
  onBack,
}) => {
  if (!error) return null;

  return (
    <Box sx={errorContainerStyles}>
      <Alert severity="error" sx={errorAlertStyles}>
        {error}
      </Alert>
      <Button startIcon={<ArrowBack />} onClick={onBack}>
        Back to Workflows
      </Button>
    </Box>
  );
};
